const TalkableWidget = () => (
  <div className="talkable-widget">
    <div id="talkable-offer" data-testid="talkable-offer" />
  </div>
);

export default TalkableWidget;
